const FETCH = '@@messages/FETCH';
const FETCH_SUCCESS = '@@messages/FETCH_SUCCESS';
const FETCH_FAIL = '@@messages/FETCH_FAIL';

const READALL = '@@messages/READALL';
const READALL_SUCCESS = '@@messages/READALL_SUCCESS';
const READALL_FAIL = '@@messages/READALL_FAIL';

const initialState = [];

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case FETCH_SUCCESS:
			return action.result;
			break;
		case READALL_SUCCESS:
			return action.result;
			break;
		default:
			return state;
	}
}

export function fetch() {
	return {
		types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
		promise: (client) => client.call('imessage.getMyMessages')
	};
}

export function readall() {
	return {
		types: [READALL, READALL_SUCCESS, READALL_FAIL],
		promise: (client) => client.call('imessage.readAll')
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/messages.js